import createLucideIcon from '../createLucideIcon';

const BookUp = createLucideIcon('BookUp', [
  ['path', { d: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20', key: '126fyg' }],
  [
    'path',
    {
      d: 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z',
      key: '19jkyh',
    },
  ],
  ['path', { d: 'M12,13V7', key: 'qczx4r' }],
  ['path', { d: 'M9,10l3-3l3,3', key: '10ebl8' }],
]);

export default BookUp;
